import React, { memo, FC, CSSProperties } from 'react';
import styled from '@emotion/styled';
import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { MathJax } from 'better-react-mathjax';
import { useTranslation } from 'react-i18next';

const OutterBox = styled.div`
  background: #dae8fc;
  border: solid 1px;
  padding: 10px 20px;
  width: 100px;
  height: 160px;
  z-index: -1;
`;

const EdgeTxt = styled.div`
  position: absolute;
  right: 35px;
  top: 210px;
`;

const sourceHandleStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
};

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Po: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  // const f = "\\(\P_o \\)";
  return (
    <OutterBox>
      {/* <EdgeTxt>{t('α\u006F')}</EdgeTxt> */}
      <EdgeTxt>
        α<sub>o</sub>
      </EdgeTxt>
      <Handle
        type="source"
        position={Position.Bottom}
        style={sourceHandleStyle}
        isConnectable={isConnectable}
      />
      {/* <MathJax>{f}</MathJax> */}
      <MathJax>
        ρ<sub>o|s,X</sub>
      </MathJax>
    </OutterBox>
  );
};

export default memo(Po);
